/* eslint-disable class-methods-use-this */
import _ from 'lodash';
import * as api from '../../../../utils/apiClient';
import { ArraysCollections } from '../../../../utils/normalize';
import {
  restructureTaskExecModel,
  restructureExecLogModel
} from './restructuring';
import { restructureExecMaterialsModel } from '../TasksExecsMaterials/restructuring';
import { restructurePaginationModel } from '../../../../common/restructuring';

class TasksExecsService {
  async getMyTasksExecById(state, execId) {
    // console.log(queryParams);
    const response = await api.get(`/tasks-execs/view-my-exec/${execId}`, {
      expand:
        'owner.profile,task.comment_stat,task.exec_stat,task.owner.profile,exec_log,my_not_send_materials'
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    const materialsNormalize = new ArraysCollections();
    materialsNormalize.normalize(
      [responseJson.data],
      'my_not_send_materials',
      restructureExecMaterialsModel,
      state,
      'task_exec_id'
    );
    const execLogsNormalize = new ArraysCollections();
    execLogsNormalize.normalize(
      [responseJson.data],
      'exec_log',
      restructureExecLogModel,
      state,
      'task_exec_id'
    );
    return {
      response: responseJson,
      destructData: {
        tasksById: _.keyBy(
          _.map([responseJson.data], item =>
            restructureTaskExecModel(state, item)
          ),
          'id'
        ),
        noSendExecMaterials: materialsNormalize.getItems(),
        noSendExecMaterialsMapByExec: materialsNormalize.getMap(),
        execLogs: execLogsNormalize.getItems(),
        execLogsMapByExec: execLogsNormalize.getMap()
      }
    };
  }

  async getTasksExecsByTaskId(state, taskId, queryParams) {
    const response = await api.get(`/tasks-execs/by-me-tasks`, {
      expand: 'owner.profile,materials,exec_log,my_not_send_materials',
      task_id: taskId,
      ...queryParams
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    const materialsNormalize = new ArraysCollections();
    materialsNormalize.normalize(
      responseJson.data.items,
      'my_not_send_materials',
      restructureExecMaterialsModel,
      state,
      'task_exec_id'
    );
    const execLogsNormalize = new ArraysCollections();
    execLogsNormalize.normalize(
      responseJson.data.items,
      'exec_log',
      restructureExecLogModel,
      state,
      'task_exec_id'
    );
    return {
      response: responseJson,
      destructData: {
        tasksById: _.keyBy(
          _.map(responseJson.data.items, item =>
            restructureTaskExecModel(state, item)
          ),
          'id'
        ),
        tasksIds: _.map(responseJson.data.items, item => item.id),
        pagination: restructurePaginationModel(
          _.get(responseJson, 'data._meta')
        ),
        noSendExecMaterials: materialsNormalize.getItems(),
        noSendExecMaterialsMapByExec: materialsNormalize.getMap(),
        execLogs: execLogsNormalize.getItems(),
        execLogsMapByExec: execLogsNormalize.getMap()
      }
    };
  }

  async getTasksExecsByAuthUser(state, queryParams) {
    // console.log(queryParams);
    const response = await api.get(`/tasks-execs/me`, {
      expand:
        'owner.profile,task.comment_stat,task.exec_stat,task.time_target,task.owner.profile,exec_log,my_not_send_materials',
      ...queryParams
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    const materialsNormalize = new ArraysCollections();
    materialsNormalize.normalize(
      responseJson.data.items,
      'my_not_send_materials',
      restructureExecMaterialsModel,
      state,
      'task_exec_id'
    );
    const execLogsNormalize = new ArraysCollections();
    execLogsNormalize.normalize(
      responseJson.data.items,
      'exec_log',
      restructureExecLogModel,
      state,
      'task_exec_id'
    );
    return {
      response: responseJson,
      destructData: {
        tasksById: _.keyBy(
          _.map(responseJson.data.items, item =>
            restructureTaskExecModel(state, item)
          ),
          'id'
        ),
        tasksIds: _.map(responseJson.data.items, item => item.id),
        pagination: restructurePaginationModel(
          _.get(responseJson, 'data._meta')
        ),
        noSendExecMaterials: materialsNormalize.getItems(),
        noSendExecMaterialsMapByExec: materialsNormalize.getMap(),
        execLogs: execLogsNormalize.getItems(),
        execLogsMapByExec: execLogsNormalize.getMap()
      }
    };
  }

  async getTasksExecsByTaskOwner(state, queryParams) {
    // console.log(queryParams);
    const response = await api.get(`/tasks-execs/by-me-tasks`, {
      expand:
        'owner.profile,task.comment_stat,task.exec_stat,task.owner,task.owner.profile,task.time_target,task.up_list_fasten_now,task.up_list_mark_now,exec_log,my_not_send_materials',
      ...queryParams
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    const materialsNormalize = new ArraysCollections();
    materialsNormalize.normalize(
      responseJson.data.items,
      'my_not_send_materials',
      restructureExecMaterialsModel,
      state,
      'task_exec_id'
    );
    const execLogsNormalize = new ArraysCollections();
    execLogsNormalize.normalize(
      responseJson.data.items,
      'exec_log',
      restructureExecLogModel,
      state,
      'task_exec_id'
    );
    return {
      response: responseJson,
      destructData: {
        tasksById: _.keyBy(
          _.map(responseJson.data.items, item =>
            restructureTaskExecModel(state, item)
          ),
          'id'
        ),
        tasksIds: _.map(responseJson.data.items, item => item.id),
        pagination: restructurePaginationModel(
          _.get(responseJson, 'data._meta')
        ),
        noSendExecMaterials: materialsNormalize.getItems(),
        noSendExecMaterialsMapByExec: materialsNormalize.getMap(),
        execLogs: execLogsNormalize.getItems(),
        execLogsMapByExec: execLogsNormalize.getMap()
      }
    };
  }

  async getTasksExecsAuthUserByTask(state, taskId, queryParams) {
    // console.log(queryParams);
    const response = await api.get(`/tasks-execs/me`, {
      task_id: taskId,
      expand:
        'owner.profile,task.comment_stat,task.exec_stat,task.owner,task.owner.profile,task.time_target,task.up_list_fasten_now,task.up_list_mark_now,exec_log,my_not_send_materials',
      ...queryParams
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    const materialsNormalize = new ArraysCollections();
    materialsNormalize.normalize(
      responseJson.data.items,
      'my_not_send_materials',
      restructureExecMaterialsModel,
      state,
      'task_exec_id'
    );
    const execLogsNormalize = new ArraysCollections();
    execLogsNormalize.normalize(
      responseJson.data.items,
      'exec_log',
      restructureExecLogModel,
      state,
      'task_exec_id'
    );
    return {
      response: responseJson,
      destructData: {
        tasksById: _.keyBy(
          _.map(responseJson.data.items, item =>
            restructureTaskExecModel(state, item)
          ),
          'id'
        ),
        tasksIds: _.map(responseJson.data.items, item => item.id),
        pagination: restructurePaginationModel(
          _.get(responseJson, 'data._meta')
        ),
        noSendExecMaterials: materialsNormalize.getItems(),
        noSendExecMaterialsMapByExec: materialsNormalize.getMap(),
        execLogs: execLogsNormalize.getItems(),
        execLogsMapByExec: execLogsNormalize.getMap()
      }
    };
  }

  async getTasksExecLogListByExec(state, execId) {
    const response = await api.get(`/tasks-execs-log/by-exec/${execId}`, {
      sort: 'id'
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        items: _.keyBy(
          _.map(responseJson.data.items, item =>
            restructureExecLogModel(state, item)
          ),
          'id'
        ),
        mapItems: _.chain(responseJson.data.items)
          .groupBy('task_exec_id')
          .mapValues(item => _.map(item, children => children.id))
          .value()
      }
    };
  }

  async getMoreUserReports(state, execId) {
    const response = await api.get(
      `/tasks-execs-log/get-more-user-reports/${execId}`,
      {
        sort: 'id'
      }
    );
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        items: responseJson.data.items.map(item =>
          restructureExecLogModel(state, item)
        ),
        pagination: restructurePaginationModel(
          _.get(responseJson, 'data._meta')
        )
      }
    };
  }

  async createTaskExec(state, taskId) {
    // console.log(queryParams);
    const response = await api.post(
      `/tasks-execs`,
      {},
      {
        task_id: taskId
      }
    );
    const responseJson = await response.json();
    return responseJson;
  }

  async addComment(state, execId, body) {
    const response = await api.post(`/tasks-execs/comment/${execId}`, {}, body);
    const responseJson = await response.json();
    return responseJson;
  }

  async createDispute(state, execId, body) {
    const response = await api.post(`/tasks-execs/dispute/${execId}`, {}, body);
    const responseJson = await response.json();
    return responseJson;
  }

  async sendReport(state, execId, body) {
    const response = await api.post(`/tasks-execs/report/${execId}`, {}, body);
    const responseJson = await response.json();
    return responseJson;
  }

  async sendRefuse(state, execId) {
    const response = await api.post(`/tasks-execs/refuse/${execId}`, {}, {});
    const responseJson = await response.json();
    return responseJson;
  }

  async sendConfirm(state, execId) {
    const response = await api.post(`/tasks-execs/confirm/${execId}`, {}, {});
    const responseJson = await response.json();
    return responseJson;
  }

  async sendRemake(state, execId, body) {
    const response = await api.post(`/tasks-execs/remake/${execId}`, {}, body);
    const responseJson = await response.json();
    return responseJson;
  }

  async sendCancelByOwner(state, execId, body) {
    const response = await api.post(
      `/tasks-execs/cancel-by-owner/${execId}`,
      {},
      body
    );
    const responseJson = await response.json();
    return responseJson;
  }

  async sendAnswerConfirm(state, execId, body) {
    const response = await api.post(
      `/tasks-execs/answer-confirm/${execId}`,
      {},
      body
    );
    const responseJson = await response.json();
    return responseJson;
  }
}

export default new TasksExecsService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/services/TasksExecsService/TasksExecsService.js